import { Alert, Button, Flex, Form, Input, Space,Checkbox } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import loginbig from '../../Images/loginimg.jpg';
import logincl1 from '../../Images/login-cl-1.png';
import logincl2 from '../../Images/login-cl-2.png';
import logincl3 from '../../Images/login-cl-3.png';
import logincl4 from '../../Images/login-cl-4.png';
import logincl5 from '../../Images/login-cl-5.png';
import logo from '../../Images/logo-white.svg';
import logow from '../../Images/logo.svg';
import { login } from '../../slices/auth';
import { clearMessage } from '../../slices/message';
import { fetchAndSetIpAddress, setIpAddress } from '../../slices/ipSlice';
import { ReactComponent as Email } from "../../Images/Email.svg";
import { ReactComponent as Password } from "../../Images/Password.svg";
function Login() {
  const [form] = Form.useForm();
  let navigate = useNavigate();

  const initialState = {
    email: '',
    password: '',
  };
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const emailInputRef = useRef();
  const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);
  const dispatch = useDispatch();
    const [rememberMe, setRememberMe] = useState(true);
 const handleCheckboxChange = (e) => {
    setRememberMe(e.target.checked);
    setState({ ...state, keep_me_logged_in: e.target.checked });
  };
  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        dispatch(clearMessage());
        form.resetFields();
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);
  const handleChange = e => {
    let { value } = e.target;
    setState({
      ...state,
      password: value,
    });
  };
  const onChange = e => {
    let { value } = e.target;
    setState({
      ...state,
      email: value,
    });
  };

  const handleSubmit = async () => {
    await dispatch(fetchAndSetIpAddress());
    try {
      const { email, password } = state;
      setLoading(true);
      dispatch(login({ email, password }))
        .unwrap()
        .then(() => {
          navigate('/dashboard');
        })
        .catch(error => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <>
      <section className="Login-Form-Page">

        <div className="loginleft">
          <div className='leftinside'>
            <div className="formContent">
              <div className="logow">
                <img
                  className="NavLogo"
                  src={logow}
                  alt=""
                ></img>
              </div>
              <div className='title'>
                <h3>Welcome to Alux!</h3>
                <h6>Enter your information to login</h6>
              </div>

              {message && <Alert message={message} type="error" />}
              <Form
                form={form}
                onFinish={handleSubmit}
                autoComplete="off"
                layout="vertical"
              >
                <Form.Item
                
                  name="email"
                  label="Username or Email"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter a valid username or email!',
                    },
                  ]}
                >
                  <Input
                  prefix={<Email />}
                    placeholder="Enter Username or Email"
                    onChange={onChange}
                    ref={emailInputRef}
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid password!',
                    },
                  ]}
                  style={{ marginBottom: '0px' }}
                >
                  <Input.Password
                  prefix={<Password />}
                    placeholder="Please Enter Password"
                    onChange={handleChange}
                    value={state.password}
                  />
                </Form.Item>
              
                <div className="CheckBoxFeild">
                  <Checkbox onChange={handleCheckboxChange} defaultChecked>
                    Keep me logged in on this device
                  </Checkbox>
                  <div className="forgotpassword">
                    <Link to="/forgot-password" className="link">Forgot Password ?</Link>
                  </div>
                </div>
                <ul>
                  <li>Contain atleast 1 uppercase letter</li>
                  <li>Contain atleast 1 special character</li>
                  <li>Contain atleast 1 number</li>
                  <li>Password length should be atleast 8 characters</li>
                </ul>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Login to your account
                  </Button>
                </Form.Item>
              </Form>

            </div>

          </div>
          <div className="loginfooter">
            <div className="links">
              <Space>
                <a href="https://aluxerp.com/privacy-policy" target='_blank'>Privacy Policy</a> | <a href="https://aluxerp.com/terms-and-condition" target='_blank'>Terms & Conditions</a> |{' '}
                <a href="https://aluxerp.com/contact" target='_blank'>
                  Contact
                </a>
              </Space>
            </div>


            <div className="colpyr">
              <p>
                Copyright&copy; {(new Date().getFullYear())}{' '}
                <a href="https://nivzen.com/" target='_blank'>Nivzen Technologies</a> All rights reserved.
              </p>
            </div>
          </div>
        </div>
        <div className="loginright">

          <div className="logincont">
            <div className="logod">
              <img
                className="NavLogo"
                src={logo}
                alt=""
              ></img>
            </div>
            <h3>
              Experience Next-Level Business Efficiency
            </h3>
            <p>
              Embrace efficiency and transparency for business success. Our solutions empower you to operate effectively, communicate transparently, and achieve your goals. Join us and transform your business today.
            </p>

          </div>


        </div>
      </section>
    </>
  );
}

export default Login;